import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { AlertTriangle, Clock, Droplets, Shield } from "lucide-react";

export const ComplianceOverviewSection: React.FC<{ data: any }> = ({ data }) => {

  const complianceWaterQualityKPIs = [
    {
      title: "Overall Compliance",
      count: `${data?.complianceKpis?.overallCompliance?.value}%`,
      icon: <Shield className="h-6 w-6 text-green-600" />,
      tooltip:
        "Composite compliance score based on regulatory requirements, permit conditions, and internal standards.",
    },
    {
      title: "Quality Exceedances",
      count: data?.complianceKpis?.qualityExceedances?.value || 0,
      trendSummary: data?.complianceKpis?.qualityExceedances?.subtitle,
      icon: <AlertTriangle className="h-6 w-6 text-red-600" />,
      tooltip:
        "Number of water quality parameters that exceeded regulatory limits this month.",
    },
    {
      title: "Water Quality Monitor",
      count: `${data?.complianceKpis?.waterQualityMonitor?.value || 0}%`,
      icon: <Droplets className="h-6 w-6 text-blue-600" />,
      tooltip:
        "Percentage of required water quality samples collected and analyzed on schedule.",
    },
    {
      title: "Overdue Inspections",
      count: data?.complianceKpis?.overdueInspections?.value || 0,
      icon: <Clock className="h-6 w-6 text-orange-600" />,
      tooltip: "Number of regulatory inspections that are past their due date.",
    },
  ];

  return (
    <div className="grid grid-cols-4 gap-4">
      {complianceWaterQualityKPIs.map((card, index) => (
        <QuickStatsCard
          key={index}
          title={card.title}
          count={card.count}
          trendSummary={card.trendSummary}
          icon={card.icon}
          tooltip={card.tooltip}
        />
      ))}
    </div>
  );
};